// NSTR — fix: on tablets (desktop-width mega menu, but no real mouse hover),
// tapping "Icon" / "Manifest" opened the submenu AND navigated to the
// collection at the same time.
//
// Root cause #1: on real touchscreens, a tap fires native `pointerenter`
// BEFORE `click`. The theme's header-menu component listens for pointerenter
// and opens the submenu right away — so by the time a click handler runs,
// the submenu already looks "open", making a first tap indistinguishable
// from a second tap if you check aria-expanded.
//
// Root cause #2 (the one that actually mattered here): Horizon ships its own
// click-based instant-navigation / page-transition handling (loaded via
// critical.js, very early), which runs before any listener registered later
// in <head> and initiates navigation itself. Trying to preventDefault() on
// 'click' loses that race — by the time our code runs, navigation is
// already underway.
//
// Fix: intercept at 'touchend' instead of 'click'. Calling preventDefault()
// on touchend suppresses the browser's synthetic click entirely (the classic
// "ghost click" prevention mechanism), so the theme's click-based navigation
// handler never runs at all for a first tap. The submenu is already visible
// by then (opened by the native pointerenter at touchstart), so nothing else
// needs to happen — we just stop the click from firing. A second tap on the
// same, already-open link is allowed through normally.
(function () {
  function isTouchNoHover() {
    return window.matchMedia('(hover: none), (min-width: 750px) and (pointer: coarse)').matches;
  }

  let tapOpenedLink = null;

  function handleTapAttempt(event, link) {
    if (!link) {
      // Tapped elsewhere (a sub-link, or outside the menu) — reset, so the
      // next visit to a top-level item starts fresh with a first tap.
      tapOpenedLink = null;
      return;
    }

    if (tapOpenedLink !== link) {
      event.preventDefault();
      tapOpenedLink = link;
    } else {
      tapOpenedLink = null;
    }
  }

  // Primary path: real touchscreens.
  document.addEventListener(
    'touchend',
    function (event) {
      if (window.innerWidth < 750) return; // mobile uses the drawer menu, not this one
      var link = event.target.closest('.menu-list__link[aria-haspopup="true"]');
      handleTapAttempt(event, link);
    },
    { capture: true, passive: false }
  );

  // Fallback for coarse-pointer devices that don't fire touch events at all
  // (rare — e.g. some pen/hybrid input). Best effort only.
  document.addEventListener(
    'click',
    function (event) {
      if (window.innerWidth < 750) return;
      if ('ontouchstart' in window) return; // already handled by touchend above
      if (!isTouchNoHover()) return;
      var link = event.target.closest('.menu-list__link[aria-haspopup="true"]');
      handleTapAttempt(event, link);
    },
    true
  );
})();
